import React, { useState, useEffect } from 'react'
import { Link } from "react-router-dom"
import OddBatchFilter from "./OddBatchFilter"
import OddBatchTable from "./OddBatchTable"
import { Pagination } from 'antd'
import { getListOddBatch } from '../../../services/api/3dApi'

const OddBatchPage = () => {
    const [listOddBatch, setListOddBatch] = useState([])
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(20)
    const [startCreate, setStartCreate] = useState('')
    const [name, setName] = useState('')
    const [nameGraft, setNameGraft] = useState('')
    const [total, setTotal] = useState(0)
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const [status, setStatus] = useState('')

    const fetchListOddBatch = async () => {
        setLoading(true)
        try {
            const payload = {
                page,
                limit,
                sort: 'desc'
            }

            if (name) payload.input = name
            if (nameGraft) payload.output = nameGraft
            if (status) payload.statuses = status
            const { created = {} } = Object.assign({}, startCreate)

            if (!!created.from && !!created.to) {
                const { from, to } = created
                const fromParts = from.split(/[\s/:]/)
                const fromDate = new Date(fromParts[2], fromParts[1] - 1, fromParts[0], fromParts[3], fromParts[4])

                const toParts = to.split(/[\s/:]/)
                const toDate = new Date(toParts[2], toParts[1] - 1, toParts[0], toParts[3], toParts[4])

                payload.created = {
                    from: fromDate.toISOString(),
                    to: toDate.toISOString()
                }
            }
            const { data: res } = await getListOddBatch(payload)
            const { data, success, message } = res
            if (!success) return setError(message)

            const { jobs = [], total = 0 } = Object.assign({}, data)
            setListOddBatch(jobs)
            setTotal(total)

        } catch (error) {
            setError(error.message)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchListOddBatch()
    }, [page, limit, name, startCreate, status, nameGraft])

    const _handlePageChange = page => {
        setPage(page)
    }

    const _handleShowSizeChange = (current, size) => {
        setLimit(size)
        setPage(1)
    }

    const _handleChageName = (name) => {
        setName(name.trim())
        setPage(1)
    }

    const _handleChageNameGraft = (name) => {
        setNameGraft(name.trim())
        setPage(1)
    }

    const _handleChangeDate = (field, filter) => {
        setStartCreate({ ...filter })
        setPage(1)
    }

    const _handleChangeStatus = (id, status) => {
        const newListOddBatch = listOddBatch.map(item => {
            if (item._id === id) {
                return {
                    ...item,
                    status
                }
            }

            return item
        })

        setListOddBatch(newListOddBatch)
    }

    const _handleChangeStatusFilter = (field, value) => {
        setStatus(value)
        setPage(1)
    }

    return (
        <div className='LabelPage OddBatchPage'>
            <div className='container-fluid min-vh-100'>
                <div className='col-12 mx-auto bg-white shadow-sm py-3 px-0 px-3'>
                    <div className="mt-3">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h3 className='m-0'>Danh sách job ghép lô lẻ</h3>
                            <div>
                                <Link
                                    className={`ant-btn`}
                                    to="/batches"
                                >
                                    Quay về danh sách lô
                                </Link>
                            </div>
                        </div>

                        <div className="jumbotron px-3 pb-0 pt-3 mb-3">
                            <OddBatchFilter
                                startCreate={startCreate}
                                onChangeName={_handleChageName}
                                onChageNameGraft={_handleChageNameGraft}
                                onChangeDate={_handleChangeDate}
                                onChangeStatus={_handleChangeStatusFilter}
                            />
                        </div>

                        <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                            <div>
                                {error && (
                                    <div className="text-danger mb-2">{error}</div>
                                )}
                            </div>
                            <Pagination current={page} total={total} pageSize={limit}
                                showTotal={(sum, range) => sum > 0 &&
                                    <div>{`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} jobs`}</strong>
                                    </div>}
                                onChange={_handlePageChange}
                                className='text-right' showSizeChanger
                                pageSizeOptions={['10', '20', '50', '100']}
                                onShowSizeChange={_handleShowSizeChange} />
                        </div>

                        <OddBatchTable
                            loading={loading}
                            reload={fetchListOddBatch}
                            listOddBatch={listOddBatch}
                            onChangeStatus={_handleChangeStatus}
                        />

                        <Pagination
                            current={page} total={total} pageSize={limit}
                            onChange={_handlePageChange}
                            showQuickJumper
                            className='CustomPagination text-right' showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            onShowSizeChange={_handleShowSizeChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OddBatchPage